import { render } from "./CompanySearch.vue?vue&type=template&id=bc542d5a"
import script from "./CompanySearch.vue?vue&type=script&lang=js"
export * from "./CompanySearch.vue?vue&type=script&lang=js"

import "./CompanySearch.vue?vue&type=style&index=0&id=bc542d5a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__